import React from "react";
import Axios from "axios";
import { antdMessageError, antdMessageInfo } from "../../helpers/Utils";
import {
  availableCountries,
  shipmentAdditionalServicesAttributesParams,
  shipment_type_setter,
} from "../../helpers/OrdersFunctionsGlobal";
import { log } from "../../helpers/log";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import { orderRowFilteredForBulk } from "../../helpers/OrderRowRules";
import { validCreatingShipment } from "../../helpers/ShipmentRules";

export const validBulkAction = () => async (_, getState) => {
  const bulk_shipments = getState().orders.bulk_shipments;
  const params = {
    orders: buildParams(bulk_shipments),
  };

  if (
    !Object.values(params.orders)
      .flat()
      .every((shipment) => {
        const id_order = bulk_shipments[shipment.order_id].at(0)?.id_order;
        const { isValid } = validCreatingShipment(shipment, id_order);
        return isValid;
      })
  ) {
    return { success: false };
  }

  return { success: true, params };
};

export const shipmentBulkAction = () => async (dispatch) => {
  try {
    antdAsyncMessageLoading({
      key: "bulk_shipment_progress",
      text: <span id="bulk_shipment_progress">In progress...</span>,
    });
    const values = await dispatch(validBulkAction());
    if (!values.success) throw new Error("ERR");

    // return true
    const { data } = await Axios.post("/api/v1/bulk_shipments", values.params);
    // Error Handler

    if (data.success) {
      return true;
    }
    throw new Error("ERR");
  } catch (err) {
    console.log({ err });
    antdAsyncMessageError({ key: "bulk_shipment_progress" });
    return false;
  }
};

export const websocketShipmentBulk = (values) => async (dispatch, getState) => {
  try {
    const user_id = getState().auth.user.id;
    console.log({ values, user_id });
    if (values.user_id !== user_id) return;

    antdAsyncMessageSuccess({
      key: "bulk_shipment_progress",
      text: "Obtaining information",
    });

    const { data, errors, id_order, order_id } = values.response;

    console.log({ data });
    if (errors && !!errors.length) {
      errorHandler(id_order, errors);
    }

    if (data && Object.keys(data).length > 0) {
      console.log("Response", data);
      let old_bulk_shipments = { ...getState().orders.bulk_shipments };
      if (old_bulk_shipments[order_id]) {
        const used_pickup_address_id = data.shipment.pickup_address_id;

        old_bulk_shipments[order_id] = old_bulk_shipments[order_id].filter(
          (d) => used_pickup_address_id !== d.pickup_address_id,
        );
        antdMessageInfo(`${id_order}: successfully created`);
      }
      dispatch({
        type: "UPDATE_BULK_SHIPMENTS",
        payload: old_bulk_shipments,
      });
      dispatch({
        type: "UPDATED_ORDERS_AFTER_BULK_SHIPMENT",
        payload: {
          [order_id]: data,
        },
      });
    }

    return true;
  } catch (err) {
    console.log({ err });
    return false;
  }
};

// Functions

const errorHandler = (id_order, response_error) => {
  const build_errors = [];
  console.log({ id_order, response_error });
  response_error.forEach((item) => {
    const attr_name = Object.keys(item);
    console.log(item, attr_name);
    attr_name.forEach((d) => {
      let error_message = item[d];
      console.log({ error_message });
      build_errors.push(`${id_order}: ${d} - ${error_message}`);
    });
  });
  console.log("Builded array: ", { build_errors });
  build_errors.forEach((d) => {
    antdMessageError(d);
  });
};

const buildParams = (b_shipments) => {
  let data = { ...b_shipments };
  Object.keys(data).forEach((order_id) => {
    data[order_id] = data[order_id]
      .filter((d) => d.order_rows)
      .map((info) => {
        console.log({ info });
        const {
          values,
          address,
          order_rows,
          pickup_address_id,
          supplying_ids,
        } = info;
        const { packets, weight, shipment_type, delivery } = values;
        const {
          company,
          comment,
          country_id,
          firstname,
          lastname,
          other,
          parcel_terminal_id,
          postal_code,
          phone,
          street,
          city,
        } = address;

        const shipment_order_rows_attributes = order_rows.map((d) => ({
          quantity: d.quantity,
          order_row_id: d.id,
          price: d.unit_price_tax_incl,
        }));

        order_rows.forEach((order_row) => {
          if (!!order_row?.childs?.length) {
            order_row.childs.forEach((child) =>
              shipment_order_rows_attributes.push({
                quantity: +child.quantity || 0,
                order_row_id: child.id,
                price: child.unit_price_tax_incl,
              }),
            );
          }
        });

        const shipment = {
          order_id,
          supplying_ids,
          shipment_type: shipment_type_setter(shipment_type, delivery),
          packets,
          weight,
          pickup_address_id,
          shipment_address_attributes: {
            company,
            name: firstname + " " + lastname,
            country_id,
            address: street,
            city,
            postal_code,
            parcel_terminal_id,
            phone: phone?.trim(),
            email: other,
            comment,
          },
          shipment_order_rows_attributes,
          shipment_additional_services_attributes:
            shipmentAdditionalServicesAttributesParams({
              ...values,
              packets,
              type: shipment_type,
              created_through: "bulk_action",
            }),
        };
        return shipment;
      });
  });
  let shipments_count = 0;
  Object.entries(data).forEach((d) => {
    if (d[1].length == 0) {
      delete data[d[0]];
    } else {
      shipments_count += d[1].length;
    }
  });
  antdMessageInfo(`${shipments_count} shipments will be created`);
  return data;
};

export const orderBulkByIds =
  ({ orderIds, orderRowsIds, supplyingIds }) =>
  async (dispatch, getState) => {
    try {
      let { orders, bulk_shipments } = getState().orders;
      let { supp_date } = getState().filters.orders;

      if (!supplyingIds.length) {
        dispatch(cleanBulkAction());
        return true;
      }

      // Remove orders witch no exist in bulk_shipments
      for (let key in bulk_shipments) {
        if (!orderIds.includes(Number(key))) {
          delete bulk_shipments[key];
        }
      }

      console.log("Siuo metu duomenis");
      console.log({ bulk_shipments });

      let effect = true;
      orders.forEach(
        ({ order_rows, id: order_id, shipping_address, order_shop }) => {
          if (!orderIds.includes(order_id)) return;
          if (
            !availableCountries(
              shipping_address?.country_id,
              order_shop.country_id,
            )
          )
            return;
          order_rows = orderRowFilteredForBulk(order_rows, { supp_date });
          order_rows = order_rows
            .filter(({ manual_disabled }) => !manual_disabled)
            .map((order_row) => ({
              ...order_row,
              supplyings: order_row.supplyings.filter(
                (d) => !d.manual_disabled,
              ),
            }));

          if (
            order_rows.filter(({ id: order_row_id }) =>
              orderRowsIds.includes(order_row_id),
            ).length == 0 &&
            bulk_shipments[order_id]
          ) {
            effect = false;
            delete bulk_shipments[order_id];
          }
          order_rows.forEach((order_row) => {
            if (
              !orderRowsIds.includes(order_row.id) &&
              bulk_shipments[order_id]
            ) {
              // find unit index
              const find_unit_index = bulk_shipments[order_id].findIndex(
                (bulk_shipment) =>
                  bulk_shipment.order_row_ids.length == 1 &&
                  bulk_shipment.order_row_ids.includes(order_row.id),
              );
              if (find_unit_index !== -1) {
                effect = false;
                delete bulk_shipments[order_id].splice(find_unit_index, 1);
                return;
              }
            }
            order_row.supplyings.forEach((supplying) => {
              if (!supplyingIds.includes(supplying.id)) {
                if (bulk_shipments[order_id]) {
                  const find_unit_index = bulk_shipments[order_id].findIndex(
                    (bulk_shipment) =>
                      bulk_shipment.supplying_ids.length == 1 &&
                      bulk_shipment.supplying_ids.includes(supplying.id),
                  );
                  if (find_unit_index !== -1) {
                    delete bulk_shipments[order_id].splice(find_unit_index, 1);
                  }
                }
                return;
              }
              // Action
              if (!bulk_shipments[order_id]) bulk_shipments[order_id] = [];
              const current_pickup_address_id =
                supplying.supplier.pickup_address_id;
              const supplying_ids = [];
              const selected_order_rows = order_rows
                .filter(
                  (d) =>
                    d.supplyings.filter((child_sup) => {
                      if (
                        supplyingIds.includes(child_sup.id) &&
                        child_sup.supplier.pickup_address_id ==
                          current_pickup_address_id
                      ) {
                        supplying_ids.push(child_sup.id);
                        return true;
                      }
                      return false;
                    }).length > 0,
                )
                .map((d) => d.id);
              log(selected_order_rows);
              const initial = {
                pickup_address_id: current_pickup_address_id,
                order_row_ids: selected_order_rows,
                supplying_ids,
              };

              // check if exist
              const check_if_exist = bulk_shipments[order_id].find(
                (bulk_shipment) =>
                  bulk_shipment.pickup_address_id ==
                    initial.pickup_address_id &&
                  initial.order_row_ids.length ==
                    bulk_shipment.order_row_ids.length &&
                  bulk_shipment.order_row_ids.every((d) =>
                    initial.order_row_ids.includes(d),
                  ),
              );
              if (check_if_exist) {
                return (effect = false);
              }
              if (!!bulk_shipments[order_id].length) {
                const find_index = bulk_shipments[order_id].findIndex(
                  (d) => d.pickup_address_id == initial.pickup_address_id,
                );

                if (find_index == -1) bulk_shipments[order_id].push(initial);
                else bulk_shipments[order_id][find_index] = initial;
              } else {
                bulk_shipments[order_id] = [initial];
              }

              effect = false;
            });
          });
        },
      );

      if (!effect) {
        dispatch({
          type: "UPDATE_BULK_SHIPMENTS",
          payload: bulk_shipments,
        });
      }

      return true;
    } catch (err) {
      console.log("Order bulk action error: ", { err });
      return false;
    } finally {
      console.log("finally");
    }
  };

//

export const cleanBulkAction = () => ({
  type: "UPDATE_BULK_SHIPMENTS",
  payload: {},
});
